const collectionReadMore = () => {
  document.querySelectorAll('[data-collection-read-more]').forEach((button) => {
    const wrapper = button.closest('.collection-hero__text-wrapper');
    if (!wrapper) return;
    const description = wrapper.querySelector('[data-collapsible-description]');
    if (!description) return;

    const showMoreText = button.dataset.showMore || 'Read more';
    const showLessText = button.dataset.showLess || 'Show less';
    const suffixEl = button.querySelector('[aria-hidden="true"]');

    if (description.scrollHeight <= description.clientHeight + 1) return;

    button.classList.remove('hidden');
    button.addEventListener('click', () => {
      const expanded = description.classList.toggle('collection-hero__description--expanded');
      button.childNodes[0].textContent = expanded ? `${showLessText} ` : `${showMoreText} `;
      if (suffixEl) suffixEl.textContent = expanded ? '[-]' : '[+]';
    });
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', collectionReadMore, { once: true });
} else {
  collectionReadMore();
}
